import React, { useState, useEffect } from "react";
import "./styles.scss";
import axios from "axios";
import helpers from "service/Helper";
import moment from "moment";

export const DayEndSettlementModules = () => {
  const currentDate = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(currentDate);
  const [isMobile, setIsMobile] = useState(false);
  const [isPrintButtonEnabled, setIsPrintButtonEnabled] = useState(false);
  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = useState(true); // State to manage button
  const [paymentData, setPaymentData] = useState([]);
  const [paymentDataAdditional, setPaymentDataAdditional] = useState([]);
  const [val, setval] = useState([]);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(""); // Initialize the state for selected payment mode

  const [showAdditonalData, setShowAdditonalData] = useState(false);
  const [showLatestRecord, setShowLatestRecord] = useState(true); // Step 1
  const [newRecord, setNewRecord] = useState(false); // Step 1

  const [additionalPaymentMode, setAdditionalPaymentMode] = useState([]);
  const [jam2, setJam2] = useState([]);
  const [latestUpdatedRecord1, setLatestUpdatedRecord1] = useState([]);
  const [latestUpdatedRecordAdd, setLatestUpdatedRecordAdd] = useState([]);
  const [componentFirstRender, setComponentFirstRender] = useState(true);

  const [jam, setJam] = useState([]);
  const [newData, setNewData] = useState(false);
  const [decRec, setDecRecord] = useState([]);

  const [decRecL, setDecRecordL] = useState([]);

  const [dataStore, setDateStore] = useState([]);
  //  const [addPaymentMode,setAddPaymentMod]=useState([])
  const [saveMessage, setSaveMessage] = useState("");
  const [dataAdded, setDataAdded] = useState([]);

  const [fetchedData, setFetchedData] = useState(null);
  const [paymentModeHide, setPaymentModeHide] = useState(false);
  let latestRecordValue =
    dataAdded.length > 0
      ? dataAdded[dataAdded.length - 1].des_record
      : "New Record";

  let uniqueRecords = Array.from(
    new Set(
      dataAdded
        .map((record) => record.des_record)
        .filter(
          (record) =>
            record !== "New Record" &&
            record !== latestRecordValue &&
            record !== undefined &&
            record.trim() !== ""
        )
    )
  ).sort();

  const [selectedOption, setSelectedOption] = useState(latestRecordValue);
  const [newPaymentMode, setNewPaymentMode] = useState([
    {
      des_record: "",
      bottom_payment: " ", // Initialize with empty values
      bottom_grosssales: 0,
      bottom_gst: 0,
      bottom_netsales: 0,
      bottom_settlementamt: 0,
      bottom_remark: "",
      bottom_diffrent: 0,
    },
  ]);

  var rowsArray = [];
  for (const key in newPaymentMode) {
    if (Object.hasOwnProperty.call(newPaymentMode, key)) {
      rowsArray.push(newPaymentMode[key]);
    }
  }

  const getDailySales = () => {
    //return "http://103.253.15.184:8003/be/api/";
    return "https://jy.beautecloud.com/be/api/";
  };

  const handleSettlementAmountChange = (index, value) => {
    const updatedPaymentData = [...paymentData];

    // Validate the input format using a regular expression
    if (/^\d{1,20}(\.\d{0,2})?$/.test(value)) {
      updatedPaymentData[index].Settlement_Amount = parseFloat(value);
      updatedPaymentData[index].Settlement_AmountDisplay = value;
      setPaymentData(updatedPaymentData);
    }
  };

  const handleRemarkChange = (index, value) => {
    const updatedPaymentData = [...paymentData];
    updatedPaymentData[index].Remark = value;
    setPaymentData(updatedPaymentData);
    // console.log(updatedPaymentData, "Remark");
  };

  useEffect(() => {
    if (startDate) {
      fetchDayendsettlementAPI();
    }
  }, [startDate]);

  const fetchDayendsettlementAPI = async () => {
    try {
      const token_id = localStorage.getItem("AuthToken");

      // Construct the query parameters for the GET request
      const queryParams = `date=${startDate}`;
      const apiUrl = `dayendsettlement/?${queryParams}`;

      const response = await axios.get(getDailySales() + apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "token" + " " + token_id,
        },
      });
      // console.log(response.data, "!!!!!!!!!!!!!!!!");s
      // ______________________

      let latestDesRecord = null;
      for (const item of response.data.result) {
        if (item.des_record) {
          if (!latestDesRecord || item.des_record > latestDesRecord) {
            latestDesRecord = item.des_record;
          }
        }
      }
      console.log(latestDesRecord, "234567890 e9 ;");

      setval(latestDesRecord);

      if (latestDesRecord !== null && latestDesRecord.length > 0) {
        setSelectedOption(latestDesRecord);
      } else {
        setSelectedOption("New Record");
        latestRecordValue = undefined;
        uniqueRecords = undefined;
      }

      const groupedData = {};

      for (const item of response.data.result) {
        if (item.des_record) {
          if (!groupedData[item.des_record]) {
            groupedData[item.des_record] = [];
          }
          groupedData[item.des_record].push(item);
        }
      }

      const dataForLatestDesRecord = groupedData[latestDesRecord];

      if (dataForLatestDesRecord) {
        const selectedRecord = dataForLatestDesRecord.filter(
          (record) =>
            record.des_record === latestDesRecord &&
            record.Payment_Method !== "" &&
            !record.Remark.includes("bottom--")
        );
        setLatestUpdatedRecord1(selectedRecord);

        const bottomTableData = dataForLatestDesRecord.filter(
          (record) =>
            record.des_record === latestDesRecord &&
            record.Payment_Method.trim() !== "" &&
            record.Remark.includes("bottom--")
        );
        setLatestUpdatedRecordAdd(bottomTableData);
        setDecRecord(selectedRecord);

        console.log("Data for Latest Des Record:", dataForLatestDesRecord);
        setJam2(dataForLatestDesRecord);
      } else {
        console.log("No data found for the latestDesRecord:", latestDesRecord);
        setJam(latestDesRecord);
      }

      setDataAdded(response.data.result);

      if (selectedOption === "New Record") {
        const filteredData = response.data.result.filter(
          (item) => !item.des_record
        );
        setPaymentData(filteredData);

        const paymentMethodsFromFirstApi = new Set(
          filteredData.map((item) => item.Payment_Method)
        );

        const uniquePaymentMethods =
          response.data.Additional_PaymentMode.filter(
            (method) => !paymentMethodsFromFirstApi.has(method)
          );
        setAdditionalPaymentMode(uniquePaymentMethods);
      }
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };

  // useEffect(() => {
  //   if (val === null) {
  //     // If val is null, show C and set newData to true
  //     setShowLatestRecord(false);
  //     setNewData(true);
  //   }

  //   else {
  //     // If val is not null, show A and set newData to false
  //     setShowLatestRecord(true);
  //     setNewData(false);
  //   }
  // }, [val]);

  useEffect(() => {
    // Skip the first render to show A initially
    if (componentFirstRender) {
      setComponentFirstRender(false);
      return;
    }

    if (val === null) {
      setShowLatestRecord(false);
      setNewData(true);
    } else if (selectedOption == "New Record") {
      setShowLatestRecord(true);
      setNewData(false);
    } else {
      setShowLatestRecord(true);
      setNewData(false);
      setIsSaveButtonEnabled(false);
    }
  }, [val, componentFirstRender]);

  const handleSaveRecord = async (index) => {
    try {
      const filteredPaymentMode = newPaymentMode.filter(
        (mode) => mode.bottom_payment.trim() !== ""
      );

      const token_id = localStorage.getItem("AuthToken");
      const indexValues = [];

      rowsArray.forEach((row, index) => {
        indexValues.push(index);
      });

      const queryParams = `date=${startDate}`;

      const bparams = filteredPaymentMode
        .map((mode, index) => {
          return `bparams_${index}=${mode.bottom_payment},${
            mode.bottom_grosssales
          },${mode.bottom_netsales},
        ${mode.bottom_settlementamt},${encodeURIComponent(mode.bottom_remark)}`;
        })
        .join("&");

      const updatedData = paymentData
        .map((payment) => {
          const settlementAmount =
            payment.Settlement_Amount !== null ? payment.Settlement_Amount : 0;
          const remark = payment.Remark !== null ? payment.Remark : "";
          return `settlement_${payment.Payment_Method}=${encodeURIComponent(
            settlementAmount
          )}&${payment.Payment_Method}_remark=${encodeURIComponent(remark)}`;
        })
        .join("&");

      const apiUrl = `dayendsettlement/?${queryParams}&${bparams}&${updatedData}`;
      // console.log(apiUrl, "apiUrl apiUrl ");

      const response = await axios.put(
        getDailySales() + apiUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "token" + " " + token_id,
          },
        }
      );

      setPaymentData([]);
      setPaymentModeHide(false);
      fetchDayendsettlementAPI();
      setIsPrintButtonEnabled(true);
      setIsSaveButtonEnabled(false);
      setShowLatestRecord(true);
      setNewRecord(true);
      setShowAdditonalData(true);
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const handleOptionChange = (event) => {
    // const newSelectedOption = event.target.value;
    const newSelectedOption = event ? event.target.value : null;

    setSelectedOption(newSelectedOption);

    // alert(newSelectedOption, "zzzzzzzzzzzzz");

    if (newSelectedOption === "New Record") {
      setIsSaveButtonEnabled(true);
      setIsPrintButtonEnabled(false);
    } else {
      const selectedRecord = dataAdded.filter(
        (record) =>
          record.des_record === newSelectedOption &&
          record.Payment_Method !== "" &&
          !record.Remark.includes("bottom--")
      );

      setDateStore(selectedRecord);
      console.log(selectedRecord, " with out  bottom--");

      const bottomTableData = dataAdded.filter(
        (record) =>
          record.des_record === newSelectedOption &&
          record.Payment_Method.trim() !== "" &&
          record.Remark.includes("bottom--")
      );

      setPaymentDataAdditional(bottomTableData);
      setDecRecordL(selectedRecord);

      // setPaymentDataAdditional(bottomTableData);

      //   setDecRecordL(selectedRecord);
      console.log(bottomTableData, " with bottom--");

      // console.log(decRec[0].des_record,"des_record des_record des_recorddes_record")
      setIsSaveButtonEnabled(false);
      setIsPrintButtonEnabled(true);
    }

    setShowLatestRecord(false);
    setNewRecord(true);
  };

  const handleStartDateChange = (event) => {
    const newDate = event.target.value;
    setStartDate(newDate);
  };

  const fetchAddtionalDayendsettlementAPI = async (event) => {
    if (decRec.length > 0) {
      const token_id = localStorage.getItem("AuthToken");
      const newSelectedOption = decRec[0] ? decRec[0].des_record : " ";
      // alert(newSelectedOption);
      const apiUrl = `dayendsettlementpdf/?date=${startDate}&des_rec=${newSelectedOption}`;

      try {
        const response = await axios.get(getDailySales() + apiUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "token" + " " + token_id,
          },
        });

        // Store the fetched data in state
        setFetchedData(response.data);

        // console.log(response.data.result, "response.data");
      } catch (error) {
        // console.error("Error fetching data:", error);
      }
    }
  };
  const fetchAddtionalDayendsettlementAPI2 = async (event) => {
    if (decRecL.length > 0) {
      const token_id = localStorage.getItem("AuthToken");
      const newSelectedOption = decRecL[0] ? decRecL[0].des_record : " ";
      // alert(newSelectedOption);
      const apiUrl = `dayendsettlementpdf/?date=${startDate}&des_rec=${newSelectedOption}`;

      try {
        const response = await axios.get(getDailySales() + apiUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "token" + " " + token_id,
          },
        });

        // Store the fetched data in state
        setFetchedData(response.data);

        // console.log(response.data.result, "response.data");
      } catch (error) {
        // console.error("Error fetching data:", error);
      }
    }
  };

  const generatePrintTemplate = (apiData) => {
    console.log(apiData, "apiData apiData apiData apiData");

    const resultRows = apiData.result
      .filter((item) => item.Payment_Method.trim() !== "") // Filter out rows with empty Payment_Method
      .map(
        (item, index) => `
      <tr>
        <td>${item.Payment_Method}</td>
        <td>${item.Gross_Sales}</td>
        <td>${item.Gst}</td>
        <td>${item.Net_Sales}</td>
        <td>${item.Settlement_Amount}</td>
        <td>${item.Different}</td>
        <td>${item.Remark.replace("bottom--", "")}</td>
      </tr>
    `
      )
      .join("");
    return `
      <!DOCTYPE html>
      <html>
      <head>
      <style>
      body {
        font-family: Arial, sans-serif;
      }
      .styleRow {
        display: flex; 
        justify-content: space-evenly; 
        margin-left:60px;
     
    }
    
   
    
  
      .container {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        padding: 20px;
      }
  
      .title {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
      }
  
      .section {
        margin-top: 20px;
      }
  
      .section-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }
  
      .section-content {
        margin-left: 20px;
      }
    
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }
  
      th,
      td {
        border: 1px solid black;
        padding: 8px;
        text-align: center;
      }
  
      th {
        background-color: #f2f2f2;
        width:85px;
      }
    
  
      .totals {
        text-align: right;
        font-weight: bold;
      }
  
      .signatures {
        margin-top: 20px;
      }

      
  
      .right-align {
        text-align: right;
        display: inline-block;
        /* Add this line */
        width: 100%;
        /* Add this line */
      }
      .marginLeftSty{
        margin-left:10px
      }
      .thbody{
        border: none;
        background:white;
      }
  
      .center-align {
        text-align: center;
      }
  
      .value {
        display: inline-block;
        width: 100px;
        /* Adjust this value as needed */
        text-align: right;
      }
      .totalSty{
        position: absolute;
        /* left: 75px; */
        display: flex;
        justify-content: center;
        /* align-items: center; */
        width: 135px
      }
    </style>
    <style>
      @media print {
        body::after {
          content: none !important;
        }
      }
    </style>
      </head>
      <body>
        <div class="container">
          <div class="title">Computer Generated Day Close (Sales)</div>
          <div class="section">
            <div class="section-content">
              Site: ${apiData.itemsite_desc}(${apiData.itemsite_code})<br>
              Settlement Date: ${apiData.date} <br>
              Settlement Record: ${apiData.des_record} <br>
              Settlement User: ${apiData.user_name}<br>
            </div>
            <div class="right-align">Print Date: ${apiData.print_date}</div> <br>
          </div>
          <div class="section">
          <table>
            <tr>
              <th>Payment Mode</th>
              <th>Gross Sales</th>
              <th>GST</th>

              <th>Net Sales</th>
              <th>Settlement Amount</th>
              <th>Differences</th>
              <th> Explantions Remarks</th>
            </tr>

    <tr>
    ${resultRows}
    
    </tr>
    
  

            
            </table>
            </div>


            <br />



            <div class="section">
            <table>
              <tr>
                <th >Total</th>
                <th>${apiData.gross_sales_total}</th>
                <th>${apiData.Gst_total}</th>
  
                <th>${apiData.net_sales_total}</th>
                <th>${apiData.settlement_amount_total}</th>
                <th> ${apiData.different_total}</th>
                <th class="thbody"></th>
              </tr>
  
     
    
  
              
              </table>
              </div>

    
         

            <hr/>

            <div class="section">
            <div class="section-content signatures">
              <div class="left-align">
                <strong>Finalised (if Finished):</strong>
                <span class="value"style="margin-left: 57px;"><strong>Name:</strong></span>
                <span class="value" style="margin-left: 104px;"><strong>Signature:</strong></span>
              </div>
    <hr/>


              <br>
    

              <div class="left-align">
                Done by<span class="value" style="margin-left: 400px;">Banked in by:</span>
              </div><br>
              <div class="left-align">
                Checked
                by:<span class="value" style="margin-left: 347px;">Banked in </span><span >Checked by </span>
              </div>
  
            </div>
            <br>
            <div class="section">
              <div class="section-content right-align">
                <strong>MTD Net Sales:</strong>
                <span class="value" style="margin-left: 20px;">${apiData.MTT_Net_Sales}</span><br>
                <strong>MTD Gross Sales:</strong> <span class="value">${apiData.MTT_Gross_Sales}</span>
              </div>
  
            </div>
          </div>

        </div>
      </body>
      </html>
    `;
  };

  const handlePrintRecord = async (event, selectedIndex) => {
    await fetchAddtionalDayendsettlementAPI(event);
    await fetchAddtionalDayendsettlementAPI2(event);

    // If fetchedData is not null, open print window with PrintableComponent
    if (fetchedData) {
      const printWindow = window.open("", "_blank");
      const printTemplate = generatePrintTemplate(fetchedData);

      printWindow.document.write(printTemplate);
      printWindow.document.close();
      printWindow.print();
    }
  };

  useEffect(() => {
    {
      showLatestRecord
        ? fetchAddtionalDayendsettlementAPI()
        : fetchAddtionalDayendsettlementAPI2();
    }
  }, [decRec, decRecL]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleMediaQuery = (e) => {
      setIsMobile(e.matches);
    };

    setIsMobile(mediaQuery.matches);

    mediaQuery.addListener(handleMediaQuery);

    return () => {
      mediaQuery.removeListener(handleMediaQuery);
    };
  }, []);

  const containeres = {
    marginLeft: isMobile ? "15px" : "50px",
    marginRight: isMobile ? "15px" : "50px",
  };

  const uniqueOptions = new Set();

  const handleSettlementAmtChange = (e, rowIndex) => {
    const updatedRows = [...newPaymentMode];
    const inputValue = e.target.value;

    // Validate the input format using a regular expression
    if (/^\d{1,20}(\.\d{0,2})?$/.test(inputValue)) {
      updatedRows[rowIndex].bottom_settlementamt = inputValue;
      setNewPaymentMode(updatedRows);
    } else {
      // Handle invalid input format
      // updatedRows[rowIndex].bottom_settlementamt = "";
      // setNewPaymentMode(updatedRows);
    }
  };

  const handlePaymentModeChange = (e, rowIndex) => {
    setSelectedPaymentMode(e.target.value);
    const selectedMode = e.target.value;

    const updatedRows = [...newPaymentMode];
    updatedRows[rowIndex].bottom_payment = selectedMode;
    setNewPaymentMode(updatedRows);

    const updatedAdditionalPaymentMode = additionalPaymentMode.filter(
      (mode) => mode !== selectedMode
    );

    setAdditionalPaymentMode(updatedAdditionalPaymentMode);

    const hasEmptyRows = updatedRows.some((row) => row.bottom_payment === "");
    if (!hasEmptyRows) {
      handleAddRow();
    }
  };

  const handleAddRow = () => {
    setNewPaymentMode([
      ...newPaymentMode,
      {
        id: Date.now(),
        bottom_payment: "",
        bottom_grosssales: 0,
        bottom_gst: 0,
        bottom_netsales: 0,
        bottom_settlementamt: 0,
        bottom_remark: "",
        bottom_diffrent: 0,
      },
    ]);
  };

  const handleClearLine = () => {
    if (newPaymentMode.length > 0) {
      // Remove the last row
      const updatedRows = newPaymentMode.slice(0, -1);
      setNewPaymentMode(updatedRows);
    }
    setAdditionalPaymentMode(additionalPaymentMode);

    // setAdditionalPaymentMode([
    //   "ALIPAY",
    //   "ALLIANCE 12 MTHS",
    //   "ALLIANCE 6 MTHS",
    //   "ALLIANCE ATM",
    //   "ALLIANCE NORMAL",
    //   "AMBANK 12 MTHS",
    //   "AMBANK 6 MTHS",
    //   "AMBANK ATM",
    //   "AMBANK NORMAL",
    //   "AMEX",
    //   "AMEX 12 MTHS",
    //   "AMEX 6 MTHS",
    //   "AMEX NORMAL",
    //   "ATM",
    //   "ATOME INSTALLMENT",
    //   "BONUS POINT",
    //   "C VOUCHER",
    //   "CASH",
    //   "CHARGE",
    //   "CHEQUE",
    //   "CIMB 12 MTHS",
    //   "CIMB 6 MTHS",
    //   "CIMB CUP",
    //   "CIMB E-DEBIT",
    //   "CIMB JCB",
    //   "CIMB MASTER DEBIT",
    //   "CIMB NORMAL",
    //   "CIMB NORMAL INTERNET",
    //   "CIMB VISA DEBIT",
    //   "CITI REWARD",
    //   "CITIBANK 12 MTHS",
    //   "CITIBANK 24 MTHS",
    //   "CITIBANK 3 MTHS",
    //   "CITIBANK 36 MTHS",
    //   "CITIBANK 6 MTHS",
    //   "CITIBANK 9 MTHS",
    //   "CITIBANK INSTALLMENT",
    //   "CITIBANK NORMAL",
    //   "CONCOURSE CARD",
    //   "CONCOURSE CASH",
    //   "Corporate Account",
    //   "CREDIT NOTE",
    //   "CREDIT TRANSFER",
    //   "CUST REFERER",
    //   "DBS/POSB 12 MTHS",
    //   "DBS/POSB 24 MTHS",
    //   "DBS/POSB 36 MTHS",
    //   "DBS/POSB 6 MTHS",
    //   "DBS/POSB NORMAL",
    //   "Deposit",
    //   "DINERS",
    //   "DINERS/ALIPAY",
    //   "DINERS/ALIPAY INSTALLMENT",
    //   "DISC PRODUCT CREDIT",
    //   "DISC VOUCHER JY",
    //   "EPP 12 MTHS",
    //   "EPP 6 MTHS",
    //   "FOREIGN CURRENCY",
    //   "GRABPAY",
    //   "HLB 12 MTHS",
    //   "HLB 6 MTHS",
    //   "HLB NORMAL",
    //   "HSBC",
    //   "IPP INSTALLMENT PLAN",
    //   "JCB",
    //   "JCB/DINERS 12 MTHS",
    //   "JCB/DINERS 24 MTHS",
    //   "JCB/DINERS 6 MTHS",
    //   "JCB/DINERS NORMAL",
    //   "MALL VOUCHER",
    //   "MASTER",
    //   "MBB 12 MTHS",
    //   "MBB 24 MTHS",
    //   "MBB 6 MTHS",
    //   "MBB INSTALLMENT",
    //   "MBB MASTER DEBIT",
    //   "MBB NORMAL",
    //   "MBB VISA DEBIT",
    //   "MBF 12 MTHS",
    //   "MBF 6 MTHS",
    //   "MBF ATM",
    //   "MBF CUP",
    //   "MBF JCB",
    //   "MBF NORMAL",
    //   "MBF NORMAL-MANUAL",
    //   "Member Voucher",
    //   "NETS",
    //   "OCBC 12 MTHS",
    //   "OCBC 24 MTHS",
    //   "OCBC 36 MTHS",
    //   "OCBC 6 MTHS",
    //   "OCBC DEBIT",
    //   "OCBC INSTALLMENT",
    //   "OCBC NORMAL",
    //   "OLD BILL",
    //   "ONLINE BANKING",
    //   "ONLINE PAYMENT",
    //   "OUTSTANDING",
    //   "Pace",
    //   "PayNow",
    //   "PBB 12MTHS",
    //   "PBB 6 MTHS",
    //   "PBB ATM",
    //   "PBB NORMAL",
    //   "PREPAID",
    //   "PRODUCT CREDIT",
    //   "RHB 6 MTHS",
    //   "RHB ONLINE TRANSFER",
    //   "RHB12 MTHS",
    //   "ROAD SHOW",
    //   "SCB 12 MTHS",
    //   "SCB 24 MTHS",
    //   "SCB 36 MTHS",
    //   "SCB 6 MTHS",
    //   "SCB INSTALLMENT",
    //   "SCB NORMAL",
    //   "ShopBack",
    //   "STAFF",
    //   "TRANSFER Account",
    //   "TREATMENT ACCOUNT",
    //   "UNION PAY",
    //   "UOB 12 MTHS",
    //   "UOB 24 MTHS",
    //   "UOB 36 MTHS",
    //   "UOB 6 MTHS",
    //   "UOB ATM ",
    //   "UOB INSTALLMENT",
    //   "UOB NORMAL",
    //   "VIP PROMO",
    //   "VISA 123",
    //   "Voucher",
    //   "VOUCHER PROMO",
    // ]);
  };

  const handleClearAll = () => {
    // Reset the first row to its default values
    setNewPaymentMode([]);
    setAdditionalPaymentMode(additionalPaymentMode);

    // setAdditionalPaymentMode(additionalPaymentMode)
    // setAdditionalPaymentMode([
    //   "ALIPAY",
    //   "ALLIANCE 12 MTHS",
    //   "ALLIANCE 6 MTHS",
    //   "ALLIANCE ATM",
    //   "ALLIANCE NORMAL",
    //   "AMBANK 12 MTHS",
    //   "AMBANK 6 MTHS",
    //   "AMBANK ATM",
    //   "AMBANK NORMAL",
    //   "AMEX",
    //   "AMEX 12 MTHS",
    //   "AMEX 6 MTHS",
    //   "AMEX NORMAL",
    //   "ATM",
    //   "ATOME INSTALLMENT",
    //   "BONUS POINT",
    //   "C VOUCHER",
    //   "CASH",
    //   "CHARGE",
    //   "CHEQUE",
    //   "CIMB 12 MTHS",
    //   "CIMB 6 MTHS",
    //   "CIMB CUP",
    //   "CIMB E-DEBIT",
    //   "CIMB JCB",
    //   "CIMB MASTER DEBIT",
    //   "CIMB NORMAL",
    //   "CIMB NORMAL INTERNET",
    //   "CIMB VISA DEBIT",
    //   "CITI REWARD",
    //   "CITIBANK 12 MTHS",
    //   "CITIBANK 24 MTHS",
    //   "CITIBANK 3 MTHS",
    //   "CITIBANK 36 MTHS",
    //   "CITIBANK 6 MTHS",
    //   "CITIBANK 9 MTHS",
    //   "CITIBANK INSTALLMENT",
    //   "CITIBANK NORMAL",
    //   "CONCOURSE CARD",
    //   "CONCOURSE CASH",
    //   "Corporate Account",
    //   "CREDIT NOTE",
    //   "CREDIT TRANSFER",
    //   "CUST REFERER",
    //   "DBS/POSB 12 MTHS",
    //   "DBS/POSB 24 MTHS",
    //   "DBS/POSB 36 MTHS",
    //   "DBS/POSB 6 MTHS",
    //   "DBS/POSB NORMAL",
    //   "Deposit",
    //   "DINERS",
    //   "DINERS/ALIPAY",
    //   "DINERS/ALIPAY INSTALLMENT",
    //   "DISC PRODUCT CREDIT",
    //   "DISC VOUCHER JY",
    //   "EPP 12 MTHS",
    //   "EPP 6 MTHS",
    //   "FOREIGN CURRENCY",
    //   "GRABPAY",
    //   "HLB 12 MTHS",
    //   "HLB 6 MTHS",
    //   "HLB NORMAL",
    //   "HSBC",
    //   "IPP INSTALLMENT PLAN",
    //   "JCB",
    //   "JCB/DINERS 12 MTHS",
    //   "JCB/DINERS 24 MTHS",
    //   "JCB/DINERS 6 MTHS",
    //   "JCB/DINERS NORMAL",
    //   "MALL VOUCHER",
    //   "MASTER",
    //   "MBB 12 MTHS",
    //   "MBB 24 MTHS",
    //   "MBB 6 MTHS",
    //   "MBB INSTALLMENT",
    //   "MBB MASTER DEBIT",
    //   "MBB NORMAL",
    //   "MBB VISA DEBIT",
    //   "MBF 12 MTHS",
    //   "MBF 6 MTHS",
    //   "MBF ATM",
    //   "MBF CUP",
    //   "MBF JCB",
    //   "MBF NORMAL",
    //   "MBF NORMAL-MANUAL",
    //   "Member Voucher",
    //   "NETS",
    //   "OCBC 12 MTHS",
    //   "OCBC 24 MTHS",
    //   "OCBC 36 MTHS",
    //   "OCBC 6 MTHS",
    //   "OCBC DEBIT",
    //   "OCBC INSTALLMENT",
    //   "OCBC NORMAL",
    //   "OLD BILL",
    //   "ONLINE BANKING",
    //   "ONLINE PAYMENT",
    //   "OUTSTANDING",
    //   "Pace",
    //   "PayNow",
    //   "PBB 12MTHS",
    //   "PBB 6 MTHS",
    //   "PBB ATM",
    //   "PBB NORMAL",
    //   "PREPAID",
    //   "PRODUCT CREDIT",
    //   "RHB 6 MTHS",
    //   "RHB ONLINE TRANSFER",
    //   "RHB12 MTHS",
    //   "ROAD SHOW",
    //   "SCB 12 MTHS",
    //   "SCB 24 MTHS",
    //   "SCB 36 MTHS",
    //   "SCB 6 MTHS",
    //   "SCB INSTALLMENT",
    //   "SCB NORMAL",
    //   "ShopBack",
    //   "STAFF",
    //   "TRANSFER Account",
    //   "TREATMENT ACCOUNT",
    //   "UNION PAY",
    //   "UOB 12 MTHS",
    //   "UOB 24 MTHS",
    //   "UOB 36 MTHS",
    //   "UOB 6 MTHS",
    //   "UOB ATM ",
    //   "UOB INSTALLMENT",
    //   "UOB NORMAL",
    //   "VIP PROMO",
    //   "VISA 123",
    //   "Voucher",
    //   "VOUCHER PROMO",
    // ]);
  };

  const paymentModeShows = () => {
    setPaymentModeHide(true);
    if (true) {
      setNewPaymentMode([
        {
          bottom_payment: "",
          bottom_grosssales: 0,
          bottom_gst: 0,
          bottom_netsales: 0,
          bottom_settlementamt: 0,
          bottom_remark: "",
        },
      ]);
    }
  };

  useEffect(() => {
    if (startDate) {
      paymentModeShows();
      {
        setPaymentModeHide(false);
      }
    }
  }, [startDate]);

  return (
    <div style={containeres}>
      <>
        <div>
          <div>
            <div>
              <br />

              <div className="row" style={{ display: "flex" }}>
                <div className="col-lg-2 col-md-3 col-sm-12 widthStyle  ">
                  <p className="SettlemenetText">Settlement Date:</p>
                </div>

                <div className="col-lg-2 col-md-3 col-sm-12 widthStyleInput ">
                  <input
                    value={startDate}
                    type="date"
                    className="form-control"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={handleStartDateChange}
                  />
                </div>
                <div className="col-lg-5 col-md-2"></div>

                <div className="col-lg-3 col-sm-12 col-md-4  userNameStyle">
                  {paymentData.length > 0 && (
                    <div className="SettlemenetTextLogin">
                      <p> Login User : {paymentData[0].User_name}</p>
                    </div>
                  )}
                </div>
              </div>

              <br />

              <div className="row" style={{ display: "flex" }}>
                <div className="col-md-4 col-sm-12 widthStyle">
                  <p className="SettlemenetText">Settlement Record:</p>
                </div>

                <div className="col-md-4 col-sm-12 widthStyleInput">
                  <select
                    className="dropdown2"
                    value={selectedOption}
                    onChange={(event) => {
                      const selectedIndex = event.target.selectedIndex;
                      handleOptionChange(event, selectedIndex);
                    }}
                  >
                    {/* Render the latest record first */}
                    {latestRecordValue && (
                      <option value={latestRecordValue}>
                        {latestRecordValue}
                      </option>
                    )}

                    {/* Render "New Record" */}
                    {/* <option value="New Record" style={{display:"none"}}>New Record</option> */}
                    <option value="New Record">New Record</option>

                    {uniqueRecords !== undefined &&
                      uniqueRecords.length > 0 &&
                      uniqueRecords.map((record, index) => (
                        <option key={index} value={record}>
                          {record}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-4 "></div>
              </div>

              <br />
              <div className="row" style={{ display: "flex" }}>
                <div className="col-md-4 ">
                  {paymentData.length > 0 && (
                    <div className="SettlemenetNameStyle">
                      <div className="SettlemenetText">Settlement Name:</div>
                      <div className="SettlemenetText">
                        {paymentData[0].User_name}
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-4 "></div>

                <div
                  className="col-md-4 col-sm-12 mediaBtn "
                  style={{ display: "flex", gap: 10 }}
                >
                  <div>
                    <button
                      type="button"
                      className="btn btnStyle btnwidth"
                      disabled={selectedOption === "New Record" ? false : true}
                      onClick={handleSaveRecord}
                    >
                      Save Record
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btnStyle btnwidth"
                      disabled={selectedOption === "New Record" ? true : false}
                      // onClick={handlePrintRecord}

                      onClick={(event) => {
                        const selectedIndex = event.target.selectedIndex;
                        handlePrintRecord(event, selectedIndex);
                      }}
                    >
                      Print Record
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>

        <div style={{ textAlign: "center" }}>{saveMessage}</div>

        <br />

        <div>
          {showLatestRecord ? (
            // Render part A
            <div>
              {/* Your A part JSX code */}
              <div>
                <div>
                  <table className="table table-striped table-bordered">
                    <thead className="tableHeaderColor">
                      <tr>
                        <th className="fixed-header tableHeaderColor">
                          Payment Mode
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Gross Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">GST</th>
                        <th className="fixed-header tableHeaderColor">
                          Net Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Settlement Amount
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Different
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Remark
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {latestUpdatedRecord1.map((record, index) => (
                        <tr key={index}>
                          <td>{record.Payment_Method}</td>
                          <td>{record.Gross_Sales}</td>
                          <td>{record.Gst}</td>
                          <td>{record.Net_Sales}</td>
                          <td>{record.Settlement_Amount}</td>
                          <td>{record.Different}</td>
                          <td>{record.Remark.replace("bottom--", "")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <br />
                <div className="overflow-auto">
                  <div className="Additional_Style">
                    Additional Settlement Payment Mode{" "}
                  </div>

                  <table className="table table-striped table-bordered">
                    <thead className="tableHeaderColor">
                      <tr>
                        <th className="fixed-header tableHeaderColor">
                          Payment Mode
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Gross Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">GST</th>
                        <th className="fixed-header tableHeaderColor">
                          Net Sales
                        </th>
                        <th
                          className="fixed-header tableHeaderColor"
                          style={{ width: 180 }}
                        >
                          Settlement Amount
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Different
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Remark
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {latestUpdatedRecordAdd.map((payment, paymentIndex) => (
                        <>
                          <tr>
                            <td>{payment.Payment_Method}</td>
                            <td>{payment.Gross_Sales}</td>
                            <td>{payment.Gst}</td>
                            <td>{payment.Net_Sales}</td>
                            <td>{payment.Settlement_Amount}</td>
                            <td>
                              {typeof payment.Gross_Sales === "number" &&
                              typeof payment.Settlement_Amount === "number"
                                ? payment.Gross_Sales -
                                  payment.Settlement_Amount
                                : ""}
                            </td>
                            <td>{payment.Remark.replace("bottom--", "")}</td>
                          </tr>
                        </>
                      ))}
                    </tbody>

                    <br />
                  </table>
                </div>
              </div>
            </div>
          ) : (val === null && startDate !== currentDate) ||
            selectedOption == "New Record" ? (
            // Render part C
            <div>
              {/* Your C part JSX code */}
              {/* <h1>C</h1> */}
              <div>
                <div className="overflow-auto">
                  <table className="table table-striped table-bordered ">
                    <thead className="tableHeaderColor">
                      <tr>
                        <th
                          className="fixed-header tableHeaderColor "
                          style={{ width: "19%" }}
                        >
                          <button className="btnStyle3">Payment Mode</button>
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Gross Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">GST</th>
                        <th className="fixed-header tableHeaderColor">
                          Net Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Settlement Amount
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Different
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Remark
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentData.map((payment, index) => (
                        <tr key={index}>
                          <td style={{ width: "215px" }}>
                            {payment.Payment_Method}
                          </td>
                          <td>{payment.Gross_Sales}</td>
                          <td>{payment.Gst}</td>

                          <td>{payment.Net_Sales}</td>
                          <td>
                            <input
                              type="text"
                              value={payment.Settlement_AmountDisplay || ""}
                              onChange={(e) =>
                                handleSettlementAmountChange(
                                  index,
                                  e.target.value
                                )
                              }
                              className="day-end-input"
                              pattern="^\d{1,5}(\.\d{0,2})?$" // Allows 1 to 5 digits before the decimal and up to 2 decimal places
                            />
                          </td>

                          <td
                            style={{
                              color:
                                payment.Gross_Sales -
                                  payment.Settlement_Amount <
                                0
                                  ? "red"
                                  : "black",
                            }}
                          >
                            {typeof payment.Gross_Sales === "number" &&
                            typeof payment.Settlement_Amount === "number"
                              ? (
                                  payment.Gross_Sales -
                                  payment.Settlement_Amount
                                ).toFixed(2)
                              : " "}
                          </td>

                          <td>
                            <input
                              type="text"
                              value={payment.Remark || ""}
                              onChange={(e) =>
                                handleRemarkChange(index, e.target.value)
                              }
                              className="day-end-input"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="overflow-auto">
                  <div className="Additional_Style">
                    Additional Settlement Payment Mode{" "}
                  </div>

                  <table className="table table-striped table-bordered">
                    <thead className="tableHeaderColor">
                      <tr>
                        <th
                          className="fixed-header tableHeaderColor "
                          style={{ width: "19%" }}
                        >
                          <button
                            onClick={() => paymentModeShows()}
                            className="btnStyle2"
                          >
                            Payment Mode &nbsp; +
                          </button>
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Gross Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">GST</th>
                        <th className="fixed-header tableHeaderColor">
                          Net Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Settlement Amount
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Different
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Remark
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {paymentModeHide && (
                        <>
                          {newPaymentMode.map((row, index) => (
                            <>
                              <tr key={row.id}>
                                <td>
                                  <select
                                    className="dropdown"
                                    value={row.bottom_payment} // Bind the value to the payment mode in the row
                                    onChange={(e) =>
                                      handlePaymentModeChange(e, index)
                                    }
                                  >
                                    <option>
                                      {row.bottom_payment}

                                      {console.log(row.bottom_payment, "row")}
                                    </option>

                                    {console.log(additionalPaymentMode, "fff")}

                                    {additionalPaymentMode.map(
                                      (mode, optionIndex) => (
                                        <option key={optionIndex} value={mode}>
                                          {mode}
                                        </option>
                                      )
                                    )}
                                  </select>
                                </td>
                                <td>{row.bottom_grosssales}</td>

                                <td>{row.bottom_gst}</td>
                                <td>{row.bottom_netsales}</td>
                                <td>
                                  <td>
                                    <input
                                      type="text" // Change input type to text
                                      value={row.bottom_settlementamt || ""}
                                      onChange={(e) =>
                                        handleSettlementAmtChange(e, index)
                                      }
                                      className="day-end-input"
                                      pattern="\d+(\.\d{0,2})?" // Allows more than 5 digits before the decimal and up to 2 decimal places
                                    />
                                  </td>
                                </td>
                                <td
                                  style={{
                                    color:
                                      parseFloat(row.bottom_grosssales) -
                                        parseFloat(row.bottom_settlementamt) >=
                                      0
                                        ? "black"
                                        : "red",
                                  }}
                                >
                                  {isNaN(
                                    parseFloat(row.bottom_grosssales) -
                                      parseFloat(row.bottom_settlementamt)
                                  )
                                    ? 0
                                    : (
                                        parseFloat(row.bottom_grosssales) -
                                        parseFloat(row.bottom_settlementamt)
                                      ).toFixed(2)}
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    value={row.bottom_remark}
                                    onChange={(e) => {
                                      const updatedRows = [...newPaymentMode];
                                      updatedRows[index].bottom_remark =
                                        e.target.value;
                                      setNewPaymentMode(updatedRows);
                                    }}
                                    className="day-end-input"
                                  />
                                </td>
                              </tr>
                            </>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    order: 1,
                    width: 250,
                    gap: 10,
                  }}
                >
                  <button
                    className="btn btnStyle"
                    onClick={() => handleClearLine(paymentData.length - 1)}
                  >
                    Clear Line
                  </button>

                  <button
                    className="btn btnStyle"
                    onClick={handleClearAll} // Attach clear all function to the "Clear All" button
                  >
                    Clear All
                  </button>
                </div>
              </div>
            </div>
          ) : (
            // Render part B
            <div>
              {/* Your B part JSX code */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="overflow-auto">
                  <table className="table table-striped table-bordered">
                    <thead className="tableHeaderColor">
                      <tr>
                        <th
                          className="fixed-header tableHeaderColor"
                          style={{ width: 170 }}
                        >
                          Payment Mode
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Gross Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">GST</th>
                        <th className="fixed-header tableHeaderColor">
                          Net Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Settlement Amount
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Different
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Remark
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log(dataStore, "~~~~~~~~~~~~~~~~~~~~~~~~~~~")}
                      {dataStore.map((payment, paymentIndex) => (
                        <>
                          {" "}
                          <tr key={paymentIndex}>
                            <td>{payment.Payment_Method}</td>
                            <td>{payment.Gross_Sales}</td>
                            <td>{payment.Gst}</td>
                            <td>{payment.Net_Sales}</td>
                            <td>{payment.Settlement_Amount}</td>
                            <td>
                              {typeof payment.Gross_Sales === "number" &&
                              typeof payment.Settlement_Amount === "number"
                                ? (
                                    Number(payment.Gross_Sales) -
                                    Number(payment.Settlement_Amount)
                                  ).toFixed(2)
                                : ""}
                            </td>

                            <td>{payment.Remark}</td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                    <br />
                  </table>
                </div>

                <br />
                <div className="overflow-auto">
                  <div className="Additional_Style">
                    Additional Settlement Payment Mode{" "}
                  </div>

                  <table className="table table-striped table-bordered">
                    <thead className="tableHeaderColor">
                      <tr>
                        <th className="fixed-header tableHeaderColor">
                          Payment Mode
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Gross Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">GST</th>
                        <th className="fixed-header tableHeaderColor">
                          Net Sales
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Settlement Amount
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Different
                        </th>
                        <th className="fixed-header tableHeaderColor">
                          Remark
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {console.log(
            paymentDataAdditional,
            "paymentDataAdditional"
          )} */}
                      {paymentDataAdditional.map((payment, paymentIndex) => (
                        <>
                          {/* {console.log(payment, "payment payment payment")} */}

                          <tr>
                            <td>{payment.Payment_Method}</td>
                            <td>{payment.Gross_Sales}</td>
                            <td>{payment.Gst}</td>
                            <td>{payment.Net_Sales}</td>
                            <td>{payment.Settlement_Amount}</td>
                            <td>
                              {typeof payment.Gross_Sales === "number" &&
                              typeof payment.Settlement_Amount === "number"
                                ? payment.Gross_Sales -
                                  payment.Settlement_Amount
                                : ""}
                            </td>
                            <td>{payment.Remark.replace("bottom--", "")}</td>
                          </tr>
                        </>
                      ))}
                    </tbody>

                    <br />
                  </table>
                </div>
              </div>
            </div>
          )}
          {/* Rest of your component */}
        </div>
      </>
    </div>
  );
};
